import { render, staticRenderFns } from "./RestoreSeeThrough.vue?vue&type=template&id=144d76b0&scoped=true"
import script from "./RestoreSeeThrough.vue?vue&type=script&lang=js"
export * from "./RestoreSeeThrough.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d76b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144d76b0')) {
      api.createRecord('144d76b0', component.options)
    } else {
      api.reload('144d76b0', component.options)
    }
    module.hot.accept("./RestoreSeeThrough.vue?vue&type=template&id=144d76b0&scoped=true", function () {
      api.rerender('144d76b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/RestoreSeeThrough.vue"
export default component.exports